/* eslint-disable react/prop-types */
import DatePicker from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/RecruitmentScreen/FormField.css";
import { useState, useEffect } from "react";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../Utils/submissionListener";

export default function UseDatepicker({
  placeholderText,
  value,
  onChange,
  err,
  dateFormat,
  readOnly,
}) {
  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());

  useEffect(() => {
    // Add a listener to track submission status updates
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());
    // console.log("Is Submitted Form Field", isSubmitted);
    // console.log(isSubmitted === true ? false : readOnly);
    return () => removeListener(); // Clean up the listener on unmount
  }, [getIsSubmitted()]);
  const years = range(1890, getYear(new Date()) + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    
  <div className="input-wrapper" style={{position: "relative"}}>
      <span className={`fake-placeholder ${value ? "has-value" : ""} `}>
        {/* {value ? placeholderText : ""} */}
      </span>
      <div className="react-datepicker-popper">
        <DatePicker
          // dateFormat="MM/yyyy"
          placeholderText={placeholderText}
          closeOnScroll={true}
          isClearable={
            isSubmitted === true ? false : readOnly === true ? false : true
          }
          readOnly={isSubmitted === true ? true : readOnly}
          dateFormat={dateFormat}
          showMonthYearPicker={dateFormat === "MMMM yyyy"}
          showDateSelector={dateFormat === "DD MMMM yyyy"}
          className={value ? "has-value" : err ? "error" : ""} // Add class if value is present
          error={err}
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div className="datepicker">
              <div className="form-row">
                <select
                  className="custom-select-style"
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  className="custom-select-style"
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          selected={value} // Controlled by parent
          onChange={onChange} // Pass the date back to parent
        />
      </div>
    </div>
  );
}
